<template>
    <div class="vue-popup">
        <div class="mask" v-show="show" @click="click(false)"></div>
        <transition name="slide">
            <div class="popup-content" v-show="show" @click="bodyClick">
                <div :class="(showType === 1 || showType === 2)?'sub-content':'sub-content2'">{{ subMessage }}</div>
                <div class="native-btn-bottom" v-if="showType === 2">
                    <div class="btn-ok" @click="click(true)">{{ btn[0] }}</div>
                    <div class="line"></div>
                    <div class="btn-cancel" @click="click(false)">{{ btn[1] }}</div>
                </div>
                <div class="native-btn-bottom" v-else-if="showType === 1">
                    <div class="btn-ok" @click="click(true)">{{ btn[0] }}</div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>

export default {
    name: 'CustomDialog',
    props: ['showMessage', 'subMessage', 'type'],
    data() {
        return {
            show: this.showMessage,
            message: this.subMessage,
            showType: this.type,
            btn: ['OK', 'キャンセル']
        };
    },
    watch: {
        showMessage(newValue, oldValue) {
            console.log(newValue, oldValue);
            var that = this;
            that.showMessage = newValue;
            that.show = newValue;
        },
        subMessage(newValue, oldValue) {
            console.log(newValue, oldValue);
            var that = this;
            that.subMessage = newValue;
            that.message = newValue;
        },
        type(newValue, oldValue) {
            console.log(newValue, oldValue);
            var that = this;
            that.type = newValue;
            that.showType = newValue;
        }
    },
    methods: {
        click(state) {
            this.show = false;
            this.$emit('dialogClick', state);
        },
        bodyClick() {
            this.$emit('bodyClick');
        }
    },
};
</script>

<style scoped>

.popup-content {
    position: absolute;
    width: 60vw;
    height: 54vw;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    color: white;
    border-radius: 3vw;
    background-color: #416ADA;
    -webkit-transition: all 0.2s ease-in;
    transition: all 0.2s ease-in;
    font-size: 3vw;
}

.native-btn-bottom {
    border: #FFFFFF 0.2vw;
    border-top-style: solid;
    font-size: 3vw;
    position: absolute;
    bottom: 0;
    height: 10vw;
    display: flex;
    width: 100%;
}

.btn-ok {
    flex: 1;
    width: 50%;
    height: 10vw;
    line-height: 10vw;
}

.btn-cancel {
    flex: 1;
    width: 50%;
    height: 10vw;
    line-height: 10vw;
}

.sub-content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 44vw;
    padding-left: 2vw;
    padding-right: 2vw;
    white-space: pre-wrap;
}

.sub-content2 {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 54vw;
    padding-left: 2vw;
    padding-right: 2vw;
    white-space: pre-wrap;
}


.mask {
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    transition: all 0.2s ease-in;
}

@keyframes slideInUp {
    0% {
        transform: translate3d(0, 100%, 0);
        visibility: visible;
    }

    to {
        transform: translateZ(0);
    }
}

@keyframes slideOutDown {
    0% {
        transform: translateZ(0);
    }

    to {
        visibility: hidden;
        transform: translate3d(0, 100%, 0);
    }
}

/* 竖线 */
.line {
    width: 0.4vw;
    background: #FFFFFF;
    padding-top: 0.2vh;
    padding-bottom: 0.2vh;
}


</style>